<template>
    <div style="height: 100%;">
        <release :editId="editId"
                 :paymentEdit="paymentEdit"
                 :agentUserId="agentUserId"></release>
    </div>
</template>
<script>
    import release from '@/views/order/order.vue'
    export default {
        name: 'darenRelease',
        data () {
            return {
                editId:this.$route.query.id,
                agentUserId:this.$route.query.user_id,
                paymentEdit: true,
            }
        },
        components: {
            release
        }
    }
</script>
<style scoped>

</style>
